import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "new",
  component: withAsyncRouteLoading(() =>
    import(/* webpackChunkName: "admissions-crm" */ "./SegmentCreator").then(
      m => m.default
    )
  ),
});
